<template>
  <main-large-dialog
    :is-visible.sync="computedIsVisible"
    :title="`${$i18n.t('dialog.title.manageCard')} - ${layerName}`"
    dialog-width="60%"
    max-height="95vh"
    min-body-height="428px"
    agree-text="button.save"
    :is-valid="computedIsValid"
    :loading="loading"
    @agree="saveCard"
  >
    <template #body>
      <v-col>
        <v-row no-gutters class="align-center fill-height">
          <v-col cols="12" v-if="isFetched">
            <draggable-lists-manage-card
              v-bind="$props"
              @update:hasAnyRequiredOnRightSide="hasAnyRequiredOnRightSide = $event"
            />
          </v-col>
          <main-loader v-else />
        </v-row>
      </v-col>
    </template>
  </main-large-dialog>
</template>

<script>
import { call, get } from 'vuex-pathify';

import MainLoader from '@/components/MainLoader';
import DraggableListsManageCard from '@/components/DraggableListsManageCard';
import MainLargeDialog from '@/components/MainLargeDialog';

export default {
  name: 'ManageCardDialog',
  components: {
    MainLargeDialog,
    MainLoader,
    DraggableListsManageCard,
  },
  props: {
    isVisible: {
      type: Boolean,
      required: true,
    },
    layerId: {
      type: Number,
      required: true,
    },
    layerName: {
      type: String,
      required: true,
    },
    scope: {
      type: String,
      default: 'core',
    },
  },
  data: () => ({
    loading: false,
    isButtonDisabled: true,
    hasAnyRequiredOnRightSide: false,
    isFetched: false,
    payload: {
      name: undefined,
      filter_expression: {},
      form_schema: {},
      style_web: {},
      data_source: undefined,
    },
  }),
  computed: {
    currentLayerSchema: get('layers/currentLayerSchema'),
    computedIsVisible: {
      get() {
        return this.isVisible;
      },
      set(nV) {
        this.$emit('update:isVisible', nV);
      },
    },
    layer: get('layers/featuresLayers@:layerId'),
    defaultFormSchema: get('layers/dataSourcesForms@:layerDataSource'),
    layerFormSchema() {
      if (this.layer) {
        return this.layer.form_schema;
      }
      return undefined;
    },
    layerDataSource() {
      if (this.layer) {
        return this.layer.data_source_name;
      }
      return undefined;
    },
    hasFormSchema() {
      return this.layerFormSchema ? Object.keys(this.layerFormSchema).length > 0 : false;
    },
    computedIsValid() {
      return !this.isButtonDisabled && !this.hasAnyRequiredOnRightSide;
    },
  },
  watch: {
    computedIsVisible: {
      immediate: true,
      handler(nV) {
        if (!nV) {
          // this.$refs.form.reset();
          // this.$refs.form.resetValidation();
          // this.$refs.expressionBuilder.reset();
          this.isButtonDisabled = true;
          this.isFetched = false;
        } else {
          this.init();
        }
      },
    },
  },
  methods: {
    editLayer: call('layers/editLayer'),
    getFeaturesLayerAction: call('layers/getFeaturesLayer'),
    getDataSourceFormAction: call('layers/getDataSourceForm'),
    getLayerMetadata: call('layers/getLayerMetadata'),
    async init() {
      try {
        await this.getFeaturesLayerAction(this.layerId);
        await Promise.all([
          this.getDataSourceFormAction(this.layerDataSource),
          this.getLayerMetadata({ dataSource: this.layerDataSource }),
        ]);

        this.isButtonDisabled = false;
        this.isFetched = true;
      } catch (error) {
        console.log(error);
      }
    },
    async saveCard() {
      try {
        this.loading = true;
        await this.editLayer({
          layer_type: 'features_layers',
          layer_id: this.layerId,
          body: {
            form_schema: {
              elements: this.currentLayerSchema,
            },
          },
          scope: this.scope,
        });
        this.loading = false;
        this.computedIsVisible = false;
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
